import { SearchManager } from "./search-manager";
import { SearchUI } from "./search-ui";

export function setupSearch() {
  const searchManager = new SearchManager();
  const searchUi = new SearchUI(searchManager);
}